import { render, staticRenderFns } from "./EstudianteEventos.vue?vue&type=template&id=b60aec02&"
import script from "./EstudianteEventos.vue?vue&type=script&lang=js&"
export * from "./EstudianteEventos.vue?vue&type=script&lang=js&"
import style0 from "./EstudianteEventos.vue?vue&type=style&index=0&id=b60aec02&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports